import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import AnswerCheckbox from '../AnswerCheckbox';

import s from './AnswerBox.module.scss';

const cx = cn.bind(s);

const AnswerBox = ({
  className, value, range = 5, reverse = false, singleType, onChange, ...attrs
}) => {
  const values = Array(range).fill(1).map((_, index) => 0 - Math.floor(range / 2) + index);
  if (reverse) {
    values.reverse();
  }
  return (
    <div className={cx(className, 'wrapper')} {...attrs}>
      {values.map((iterateValue) => (
        <AnswerCheckbox
          key={iterateValue}
          checked={value === iterateValue}
          value={iterateValue}
          singleType={singleType}
          className={cx('answerCheck')}
          onChange={onChange}
        />
      ))}
    </div>
  );
};

AnswerBox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default AnswerBox;
